import * as React from 'react';
import { Typography, } from '@mui/material';
import { Member } from '@ivymobi/orbit-core';
import { Form, SaveButton, TextInput, } from '../components';
import { useTranslation } from 'react-i18next';

export interface EmailTemplateProps {
  member: Member;
  onSubmit: (data) => void;
}
export default function EmailTemplate (props: EmailTemplateProps) {
  var [t] = useTranslation();
  return (
    <>
      <Typography paragraph>邮件模板用途：</Typography>
      <Typography >1.用邮件形式向他人分享时默认的正文内容</Typography>
      <Typography paragraph>2.分享时可以更改</Typography>
      <Form defaultValues={props.member} px={0}
        onSubmit={props.onSubmit}
        toolbar={ <SaveButton label={t('YBT-ADMIN.YBT-ADMIN-020102.YBT-ADMIN-02010210')} fullWidth variant="outlined" /> }
      >
        <TextInput
          name="settings.emailTemplate"
          placeholder='请输入内容'
          label=""
          multiline
          rows={8}
          fullWidth
        />
      </Form>
    </>
  );
}